var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrowPercent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89844 1.4375L9.83594 5.5625C10.0469 5.79688 10.0469 6.14844 9.8125 6.35938C9.57812 6.57031 9.22656 6.57031 9.01562 6.33594L6.0625 3.21875V11.1875C6.0625 11.5156 5.80469 11.75 5.5 11.75C5.17188 11.75 4.9375 11.5156 4.9375 11.1875V3.21875L1.96094 6.33594C1.75 6.57031 1.39844 6.57031 1.16406 6.35938C0.929688 6.14844 0.929688 5.77344 1.14062 5.5625L5.07812 1.4375C5.19531 1.32031 5.33594 1.25 5.5 1.25C5.64062 1.25 5.78125 1.32031 5.89844 1.4375Z",
    fill: "#107F47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowPercent);
export default __webpack_public_path__ + "static/media/upArrowPercent.fa7d8af5f966e8a0b38f393e1e4cd193.svg";
export { ForwardRef as ReactComponent };